<template>
  <div>
    <b-modal 
      :id="modalID"
      header-class="px-gd-3 py-gd-2 warning"
      body-class="px-gd-3 py-gd-3"
      footer-class="px-gd-3 py-gd-2"
      size="500"
      @hide="closeModal"
      @hidden="onModalHidden"
    >
      <template #modal-header>
        <TitleModal :label="'Update your site font style'" />
        <button type="button" aria-label="Close" class="close" @click="closeModal()"><i class="fal fa-times fs-20"></i></button>
      </template>
      <template #default>
        <div class="fs-sa-16 text-dark">
          Your font style
          <span class="fs-sa-16 text-primary">"{{ fontName }}"</span>
          will be updated and it’ll change everywhere it appears on your site.
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="blue" @click="confirm()">
          <i class="fal fa-check"></i> Save
        </b-button>
        <b-button variant="default" class="ml-gd-1" @click="closeModal()">
          <i class="far fa-times"></i> Cancel
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

export default {
  components: {
    TitleModal,
  },
  data() {
    return {
      modalID: "modal-fontTemplate-update",
      show: false,
    };
  },
  computed: {
    ...mapGetters({
      modalActive: "design/modals/modalActive",
      modals: "design/modals/modals",
      // modal: "design/modal",
      // modalPayload: "design/modalPayload",
      templateFonts: "design/metadata/templateFonts",
      templateFontsLanguage: "design/metadata/templateFontsLanguage",
    }),
    modalPayload() {
      return (this.modalActive == this.modalID) ? this.modals[this.modalID].payload : {};
    },

    fontName() {
      return this.modalPayload && this.modalPayload.fontName;
    },
    fontStyle() {
      return this.modalPayload && this.modalPayload.fontStyle;
    },
    templateFont() {
      return this.templateFonts[this.fontName];
    },
    templateFontLanguage() {
      return this.templateFontsLanguage[this.fontName];
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalID);
      // this.$store.dispatch("design/setModal", { name: "" });
    },
    onModalHidden() {
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalID,
        clear: true,
        func: 'onClose',
        data: {}
      },{ root:true });
    },
    confirm() {
      this.updateTemplate();

      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalID,
        clear: true,
        func: 'onSubmit',
        data: {},
      },{ root:true });
      
      this.closeModal();
    },
    updateTemplate() {
      this.templateFontsLanguage[this.fontName].family = this.fontStyle.family;
      this.templateFontsLanguage[this.fontName].size = this.fontStyle.size;
      this.templateFonts[this.fontName].color = this.fontStyle.color;
      this.templateFontsLanguage[this.fontName].isBold = this.fontStyle.isBold;
      this.templateFontsLanguage[this.fontName].isItalic = this.fontStyle.isItalic;
      // this.templateFontsLanguage[this.fontName].isUnderline = this.fontStyle.isUnderline;

      this.$store.dispatch("design/snapshot/genSnapshot");
    },
  },
  beforeDestroy() {
    this.$store.dispatch("designIframe/modals/callback", {
      key: this.modalID,
      clear: true,
      func: 'onClose',
      data: {}
    },{ root:true });
    // this.$store.dispatch("design/setModal", { name: "" });
  },
  watch: {
    modalActive: {
      handler(next) {
        if (next == this.modalID) {
          this.$bvModal.show(this.modalID);
        }
      },
    },
  },
};
</script>